import { Button, Form, Input, InputNumber, Space } from "antd";
import { useEffect } from "react";
import { useAppSelector } from "../../../../app/store";
import LogoImg from "../../../../assets/images/demo-img.svg";
import UploadProfileImage from "../../../../components/Employees/edit/UploadProfileImage";
import CustomModal from "../../../../components/ui/CustomModal";
import Loader from "../../../../components/ui/Loader";
import { useCompanyProfileUpdateMutation } from "../../../../features/auth/authApi";
import {
  useGetBusinessDataQuery,
  useUploadPhotoInEmployeeMutation,
} from "../../../../features/employee/employeeApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";
import { convertToSnakeCase } from "../../../../utils/utils";

export default function EditCompanyProfileModal({
  handleClose,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();
  const { authInfo } = useAppSelector((state) => state.auth);

  const [
    uploadPhotoInEmployeeData,
    {
      isLoading: isImgLoading,
      isError: isImgError,
      error: imgError,
      data: imgData,
    },
  ] = useUploadPhotoInEmployeeMutation();
  const [
    companyProfileUpdate,
    {
      isLoading: isCompanyLoading,
      isError: isCompanyError,
      error: companyError,
      isSuccess: isCompanySuccess,
    },
  ] = useCompanyProfileUpdateMutation();
  // const {
  //   isLoading: isLocationLoading,
  //   isError: isLocationError,
  //   error: locationError,
  //   data: locationData,
  // } = useGetLocationQuery({});
  const {
    data: businessData,
    isError: isBusinessError,
    error: businessError,
    isLoading: isBusinessLoading,
  } = useGetBusinessDataQuery(authInfo?.business_id?.toString() || "", {
    skip: !authInfo?.business_id,
  });

  useError(isImgError, imgError, "Profile image upload fail");
  useError(isCompanyError, companyError, "Company update fail");
  // useError(isLocationError, locationError, "Get location fail");
  useError(isBusinessError, businessError, "Get business data fail");

  const onFinish = (values: any) => {
    const { location, name, employee_size, company_location, ...rest } = values;

    // const centeredLocation = locationData?.data
    //   ?.find((item) =>
    //     item?.locations?.some((el) => el?.id === company_location)
    //   )
    //   ?.locations?.find((el) => el?.id === company_location)?.center;

    const newData = {
      ...rest,
      name,
      employee_size: employee_size?.toString(),
      sub_domain: convertToSnakeCase(name),
      logo: imgData?.Location || getData?.logo,
      business_id: authInfo?.business_id,
      // geo_informations: centeredLocation,
    };

    companyProfileUpdate(newData);
  };

  const getData = businessData?.data?.business;

  useEffect(() => {
    if (Object.keys(getData || {})) {
      form.setFieldsValue({
        name: getData?.name,
        // location: getData?.name,
        employee_size: getData?.employee_size,
        address: getData?.address,
      });
    }
  }, [form, getData]);

  useEffect(() => {
    if (isCompanySuccess) {
      toast("success", "Company Information Updated Successfully");
      handleClose();
    }
  }, [handleClose, isCompanySuccess]);

  return (
    <CustomModal
      title="Company Edit Profile"
      handleClose={handleClose}
      {...rest}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        {isBusinessLoading ? (
          <Loader />
        ) : (
          <>
            <Form.Item className="mb-4">
              <UploadProfileImage
                img={imgData?.Location || getData?.logo || LogoImg}
                handleImage={(file) => uploadPhotoInEmployeeData(file)}
                isLoading={isImgLoading}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Company Name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter company name",
                },
              ]}
            >
              <Input placeholder="Enter company name" />
            </Form.Item>
            {/* <Form.Item
              name="company_location"
              label="Company Address"
              className="mb-[18px]"
              rules={[
                {
                  required: true,
                  message: "Please select address",
                },
              ]}
            >
              <Select
                placeholder="Select company address"
                size="large"
                allowClear
                showSearch
                filterOption={selectSearchMultiLabelOption}
                options={locationData?.data?.map((address) => ({
                  label: (
                    <span className="font-semibold text-base text-body-text">
                      {address?.name}
                    </span>
                  ),
                  title: address?.name,
                  options: address?.locations?.map((location) => ({
                    label: <span>{location?.name}</span>,
                    value: location?.id,
                  })),
                }))}
                suffixIcon={<SelectDropdownLgIcon />}
                loading={isLocationLoading}
              />
            </Form.Item> */}

            <Form.Item
              name="employee_size"
              label="Number of employee"
              className="mb-4"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter number of employee",
              //   },
              // ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Enter number of employee"
                disabled
              />
            </Form.Item>
            <Form.Item
              name="address"
              label="Company Address"
              className="mb-4"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter company address",
              //   },
              // ]}
            >
              <Input placeholder="Enter company address" />
            </Form.Item>

            <Space className="w-full mt-2" size={12}>
              <Button
                className="normal-dark-button modal-button"
                onClick={handleClose}
                size="middle"
              >
                Cancel
              </Button>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={isCompanyLoading}
              >
                Update
              </Button>
            </Space>
          </>
        )}
      </Form>
    </CustomModal>
  );
}
